<template>
  <div class="kanban-info">
    <div class="kanban-card">
      <div class="row first-line-card">
        <div class="col store-adress">
          <div class="kanban-card_title">Store Address</div>
          <div class="kanban-card_data data-big">{{ emplacement }}</div>
        </div>
        <div class="col kanban-number">
          <div class="kanban-card_title">Kanban n°</div>
          <div class="kanban-card_data data-big">{{ kanbanNumber }}</div>
        </div>
        <div class="col barcode">
          <barcode :value="kanbanNumber" width="2">
            La lecture du codebar a échoué
          </barcode>
        </div>
      </div>
      <div>
        <span class="kanban-card_title">Part N°:  </span><br>
        <span class="kanban-card_data data-big"> {{ chunk(kanbanId, 3) }} </span>
      </div>
      <div>
        <div class="kanban-card_data bigger-font">{{ cardDesignation }}</div>
      </div>
      <div>
        <span class="kanban-card_title">Supplier:  </span>
        <span class="kanban-card_data">{{ supplier }}</span>
      </div>
      <div class="row">
        <div class="col">
          <div class="kanban-card_title">Poids:  </div>
          <div class="kanban-card_data">{{ weight }}Kg</div>
        </div>
        <div class="col">
          <div class="kanban-card_title">N° de carte:  </div>
          <div class="kanban-card_data">{{ cardIndex }} / {{ nbCard }}</div>
        </div>
        <div class="col">
          <div class="kanban-card_title">QTY/CONT. </div>
          <div class="kanban-card_data bigger-font">{{ batchSize }}</div>
        </div>
      </div>
    </div>
    <b-button
      variant="primary"
      class="mt-3"
      @click="printCard()"
    >Imprimer</b-button>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode'
import printHeureServer from '../../api/printHeureServer.vue'

export default {
  name: 'KanbanCard',
  props: ['emplacement',
    'kanbanNumber',
    'kanbanId',
    'cardDesignation',
    'supplier',
    'weight',
    'cardIndex',
    'nbCard',
    'batchSize',
    'supplierCode',
  ],
  components: {
    barcode: VueBarcode,
  },
  methods: {
    printCard () {
        let sageBarcode = this.suuplierCode + '\\9\\9' +  this.batch_size

        if(this.cardIndex === -1) {
          sageBarcode = 'Carte à jeter'
        }
        if (!this.supplierCode) {
            this.supplierCode = ' '
        }
        let data = [{'EMPLACEMENT': this.emplacement,
                'REFERENCE': this.chunk(this.kanbanId , 3),
                'CARD_ID': this.kanbanNumber,
                'DESIGNATION': this.cardDesignation,
                'FOURNISSEUR': this.supplier,
                'CODE_FOURNISSEUR': this.supplierCode,
                'POIDS': this.weight,
                'NUM_CARTE': this.cardIndex,
                'NB_CARTE': this.nbCard,
                'TAILLE_LOT': this.batchSize,
                'SAGEBARCODE': sageBarcode }]
        printHeureServer.printCard(data).then(() => {
            this.makeToast('Impression en cours...')
            this.updateLastPrint(this.kanbanId)
        })
    },
  }
}

</script>
<style>
  .kanban-info {
    width: 100%;
    margin: 1rem auto;
  }

  .kanban-info .kanban-card {
    background-color: #ffffff;
    box-shadow: 2px 2px 15px 0 rgb(152 152 152 / 60%);
    border-radius: 10px;
    border-bottom: 12px solid #5d83e4;
    margin-bottom: 1rem;
  }

  .kanban-info .row {
    display: flex;
    justify-content: space-between;
  }

  .kanban-card_title {
    text-transform: uppercase;
    margin-right: 10px;
  }

  .kanban-card_data {
    font-weight: 700;
  }

  .kanban-card_data.bigger-font {
    font-size: 25px;
  }

  .kanban-card_data.data-big {
    font-size: 1.3em;
  }

  .lead-time,
  .batch-size,
  .supply-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #4262d4;
    border-bottom: 12px solid #5d83e4;
    color: white;
    flex-grow: 1;
    border-radius: 10px;
    padding: 0.5rem 1rem;
    position: relative;
    box-shadow: 2px 2px 15px 0 rgb(152 152 152 / 60%);
  }

  .lead-time {
    min-width: 180px;
  }

  .lead-time > img,
  .batch-size > img,
  .supply-info > img {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .batch-size {
    margin: 0 0.5rem;
  }

  .first-line-card .col {
    flex: 30%;
  }

  svg.vue-barcode-element {
    width: 165px;
    height: 95px;
  }

  @media screen and (orientation: portrait) {
    .kanban-info .kanban-card {
      font-size: 20px;
      padding: 1rem;
    }
  }

  @media screen and (orientation: landscape) {
    .kanban-info .kanban-card {
      font-size: 16px;
      padding: 0.8rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/kanban/KanbanCard.vue